module.exports = __webpack_public_path__ + "static/Coloring-Sheet-2-465aadb9536e44ba0b1bf4bfb044e19b.pdf";